<h3>
  {{ data.details.title.split(" ")[0] }}
  <span> {{ data.details.title.split(" ").slice(1).join(" ") }}</span>
</h3>
<div class="row">
  <div class="col-lg-6 mt-2" *ngFor="let item of data.details.services">
    <div
      class="row"
      [routerLink]="data.details.isDetails && getDetailsUrl(item)"
      [ngClass]="{ pointer: data.details.isDetails }"
    >
      <div class="col-7 col-md-6 col-lg-4 m-auto p-0">
        <img
          class="image p-3 p-md-0"
          src="{{ item.imageIconPath }}"
          alt="{{ item.imageAlt }}"
        />
      </div>

      <div class="col-md-12 col-lg-8 my-auto">
        <h6 class="title">{{ item.titleTr }}</h6>
        <p class="discreption" [innerHTML]="item.summary"></p>
      </div>
    </div>
  </div>
</div>
